import { useFormContext } from "react-hook-form";
import {
  Alert,
  Autocomplete,
  Box,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import { useEffect, useState } from "react";
import { makeRequest } from "../../../assets/functions_helper";
import { CustomTextField } from "../../../components/textFields";

// Función para obtener el código de país del navegador (ej. "ES", "US", "MX")
const getBrowserCountryCode = () => {
  // Intentar con navigator.language (ej. "es-ES" → "ES")
  if (navigator.language) {
    const parts = navigator.language.split('-');
    if (parts.length > 1) {
      return parts[1].toUpperCase();
    }
  }
  // Intentar con navigator.languages (primer idioma)
  if (navigator.languages && navigator.languages.length > 0) {
    const parts = navigator.languages[0].split('-');
    if (parts.length > 1) {
      return parts[1].toUpperCase();
    }
  }
  // Fallback: null (se usará el primer país de la lista)
  return null;
};

const CompletationInfo = () => {
  const { register, setValue } = useFormContext();
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");

  useEffect(() => {
    makeRequest(
      "POST",
      "users/countries",
      {},
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      () => {}
    )
      .then((response) => {
        console.log(response);
        setCountries(response);

        // Detectar país del navegador
        const browserCountryCode = getBrowserCountryCode();
        let defaultCountry = null;

        if (browserCountryCode && response.length > 0) {
          // Buscar país cuyo código coincida (insensible a mayúsculas)
          defaultCountry = response.find(
            (country) => country.code.toUpperCase() === browserCountryCode
          );
        }

        // Si no se encontró, usar el primer país de la lista
        if (!defaultCountry && response.length > 0) {
          defaultCountry = response[0];
        }

        if (defaultCountry) {
          setSelectedCountry(defaultCountry);
          setValue("countryId", defaultCountry.id);
        }

        setLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(`Ocurrió un error al completar la información`);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [setValue]);

  const handleCountryChange = (event, newValue) => {
    if (newValue) {
      setSelectedCountry(newValue);
      setValue("countryId", newValue.id);
    }
  };

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ maxWidth: 400, mx: "auto", mt: 2 }}>
          <Autocomplete
            options={countries}
            getOptionLabel={(option) => `${option.code} (${option.name})`}
            renderOption={(props, option) => (
              <Box
                component="li"
                {...props}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "#1E1E1E" : "#f5f5f5",
                  "&&": {
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "#1E1E1E" : "#f5f5f5",
                  },
                }}
              >
                <img src={option.flag} alt={option.name} width="20" />
                {option.code} ({option.name})
              </Box>
            )}
            value={selectedCountry}
            onChange={handleCountryChange}
            renderInput={(params) => (
              <CustomTextField {...params} label="Select Your Country" />
            )}
            componentsProps={{
              paper: {
                sx: {
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "#1E1E1E" : "#f5f5f5",
                  "& .MuiAutocomplete-listbox": {
                    padding: 0,
                    backgroundColor: "transparent",
                  },
                },
              },
            }}
          />
          <input type="hidden" {...register("countryId")} />

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
            <CustomTextField
              label="Code"
              value={selectedCountry?.code || ""}
              InputProps={{ readOnly: true }}
              sx={{ width: "30%" }}
            />
            <CustomTextField
              label="Phone Number"
              {...register("phoneNumber", { required: "Número de Teléfono" })}
              sx={{ flex: 1 }}
              autoComplete="off"
              inputProps={{
                autoComplete: "off",
                form: {
                  autoComplete: "off",
                },
                "aria-autocomplete": "none",
                role: "presentation",
                spellCheck: "false",
              }}
            />
          </Box>
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CompletationInfo;